import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77c8dae6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sh-service-container" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = { class: "toolbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-download" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "pagination-wrapper" }

import {searchFormConfig} from './config/search.config'
import PageSearch from '@/components/PageSearch.vue'
import {onMounted, ref} from 'vue'
import {downloadData, getPageListData} from '@/service/main/system'
import {ElLoading, ElMessage} from 'element-plus'

// 所有数据

export default /*#__PURE__*/_defineComponent({
  __name: 'SHService',
  setup(__props) {

const allData = ref<any[]>([])
// 当前页显示的数据
const currentPageData = ref<any[]>([])
// 总数据量
const totalCount = ref(0)
// 当前页码
const currentPage = ref(1)
// 每页条数
const pageSize = ref(10)
// 搜索条件
const searchParams = ref<any>({})
// 加载状态
const loading = ref(false)

// 获取所有数据
const fetchAllData = async (params: any = {}) => {
  loading.value = true
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '加载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })

  try {
    const res = await getPageListData('/main/shService/queryUseRecord', params)
    allData.value = res
    totalCount.value = allData.value.length
    console.log('allData:', res)
    // 更新当前页数据
    updatePageData()
  } catch (error) {
    console.error('获取数据失败:', error)
  } finally {
    loading.value = false
    loadingInstance.close()
  }
}

// 根据页码和每页条数更新当前页数据
const updatePageData = () => {
  const start = (currentPage.value - 1) * pageSize.value
  const end = start + pageSize.value
  currentPageData.value = allData.value.slice(start, end)
}

// 处理页码变化
const handlePageChange = (page: number) => {
  currentPage.value = page
  updatePageData()
}

// 处理每页条数变化
const handlePageSizeChange = (size: number) => {
  pageSize.value = size
  currentPage.value = 1
  updatePageData()
}

// 处理搜索
const handleSearchClick = (formData: any) => {
  searchParams.value = formData
  currentPage.value = 1
  fetchAllData(formData)
}

// 处理重置
const handleResetClick = () => {
  searchParams.value = {}
  currentPage.value = 1
  fetchAllData({})
}

const handleDownload = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })

  try {
    const res = await downloadData('/main/shService/download', searchParams.value, 'blob')
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download = `软件使用记录_${new Date().getTime()}.xlsx`
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
    ElMessage.success('下载成功')
  } catch (error) {
    console.error('下载失败:', error)
    ElMessage.error('下载失败，请重试')
  } finally {
    loadingInstance.close()
  }
}

onMounted(() => {
  fetchAllData({})
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClick,
      onSearchBtnClick: handleSearchClick
    }, null, 8, ["searchFormConfig"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleDownload
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" 导出数据 ")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_table, {
        data: currentPageData.value,
        border: "",
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "userAccount",
            label: "客户账号",
            "min-width": "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "客户名称",
            "min-width": "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "trueName",
            label: "助理名称",
            "min-width": "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "trueNameP",
            label: "助理经理",
            "min-width": "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "isTodayUseApp",
            label: "当天是否登录App",
            "min-width": "80"
          }, {
            default: _withCtx((scope) => [
              (scope.row.isTodayUseApp === 0 || scope.row.isTodayUseApp == null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "否"))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "是"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "lastUseApp",
            label: "最近一次登录时间(App)",
            "min-width": "80"
          }),
          _createVNode(_component_el_table_column, {
            prop: "isTodayUsePc",
            label: "当天是否登录Pc",
            "min-width": "80"
          }, {
            default: _withCtx((scope) => [
              (scope.row.isTodayUsePc === 0 || scope.row.isTodayUsePc == null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "否"))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "是"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "lastUsePc",
            label: "最近一次登录时间(Pc)",
            "min-width": "80"
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
          "page-sizes": [10, 20, 50, 100],
          total: totalCount.value,
          layout: "total, sizes, prev, pager, next, jumper",
          onCurrentChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ])), [
      [_directive_loading, loading.value]
    ])
  ]))
}
}

})